import PropTypes from 'prop-types';
import React from 'react';
import './onboardingTooltip.scss';

const OnboardingTooltip = ({ backProps, index, isLastStep, primaryProps, skipProps, step, tooltipProps }) => {
  const isFirstStep = index === 0;
  return (
    <div
      {...tooltipProps}
      className="onboardingTooltip"
    >
      {step.content}
      <div className="onboardingTooltipButtons">
        <div>
          <button
            type="button"
            className="button primary outline"
            {...skipProps}
          >
            {isFirstStep ? 'Skip tour' : 'End tour'}
          </button>
        </div>
        <div>
          {!isFirstStep && (
            <button
              type="button"
              className="button primary"
              {...backProps}
            >
              Prev
            </button>
          )}
          {!isLastStep && (
            <button
              type="button"
              className="button primary"
              {...primaryProps}
            >
              Next
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default OnboardingTooltip;

OnboardingTooltip.propTypes = {
  backProps: PropTypes.shape({
    'aria-label': PropTypes.string,
    onClick: PropTypes.func,
    role: PropTypes.string,
    title: PropTypes.string
  }),
  closeProps: PropTypes.shape({
    'aria-label': PropTypes.string,
    onClick: PropTypes.func,
    role: PropTypes.string,
    title: PropTypes.string
  }),
  continuous: PropTypes.bool,
  index: PropTypes.number.isRequired,
  isLastStep: PropTypes.bool.isRequired,
  primaryProps: PropTypes.shape({
    'aria-label': PropTypes.string,
    onClick: PropTypes.func,
    role: PropTypes.string,
    title: PropTypes.string
  }),
  skipProps: PropTypes.shape({
    'aria-label': PropTypes.string,
    onClick: PropTypes.func,
    role: PropTypes.string,
    title: PropTypes.string
  }),
  step: PropTypes.shape({
    content: PropTypes.node.isRequired,
    hideBackButton: PropTypes.bool,
    hideCloseButton: PropTypes.bool,
    placement: PropTypes.string,
    target: PropTypes.string
  }).isRequired,
  tooltipProps: PropTypes.shape({
    'aria-modal': PropTypes.bool,
    role: PropTypes.string
  })
};
